import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import getV1StockOdtOrderHistorytradefilter from '@services/api/stock/history/dt';

function useHistoryDt() {
  const { cb, key } = getV1StockOdtOrderHistorytradefilter();

  const {
    data,
    isInitialLoading,
    refetch,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(key, cb, {
    getNextPageParam: (lastPage, allPages) => lastPage?.paging?.next && allPages.length + 1,
    select: (_data) => _data.pages?.flatMap((page) => page?.results || []),
  });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    refetch,
    isRefetching,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
  };
}

export default useHistoryDt;
